const HERO_IMAGE_PATH = "/hero.webp";
const HERO_MOBILE_PATH = "/hero-mobile.webp";
const HERO_MOBILE_WIDTH = "1100w";
const HERO_FULL_WIDTH = "1800w";

let started = false;

function publicUrl(path) {
  const base = process.env.PUBLIC_URL || "";
  return `${base}${path}`;
}

export function heroImageUrl() {
  return publicUrl(HERO_IMAGE_PATH);
}

export function heroImageSrcSet() {
  return `${publicUrl(HERO_MOBILE_PATH)} ${HERO_MOBILE_WIDTH}, ${publicUrl(HERO_IMAGE_PATH)} ${HERO_FULL_WIDTH}`;
}

function currentPath() {
  if (typeof window === "undefined") return "";
  return (window.location.pathname || "/").replace(/\/+$/, "") || "/";
}

// Only the landing hero is preloaded. The mobile file is the one a 360px
// phone actually paints; the full photo stays available for wider screens.
export function preloadHeroImage() {
  if (started || typeof document === "undefined") return;
  if (currentPath() !== "/") return;
  started = true;

  const existing = document.head.querySelector('link[rel="preload"][as="image"][imagesrcset*="hero-mobile.webp"]');
  if (existing) return;

  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = heroImageUrl();
  link.setAttribute("imagesrcset", heroImageSrcSet());
  link.setAttribute("imagesizes", "(max-width: 767px) 100vw, 1800px");
  link.setAttribute("fetchpriority", "high");
  document.head.appendChild(link);
}

export function preloadCriticalImages() {
  preloadHeroImage();
}
